module.exports = __webpack_public_path__ + "img/logo.a7c98d27.png";